import firebase from 'firebase'
import firestore from 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyDhz9wJwHZL-ZgzPybKFsIm5-VlNNOf640",
    authDomain: "geopersonen.firebaseapp.com",
    databaseURL: "https://geopersonen.firebaseio.com",
    projectId: "geopersonen",
    storageBucket: "",
    messagingSenderId: "640363983459",
    appId: "1:640363983459:web:1961c6882f47c998dd7e56"
};
// Initialize Firebase
const firebaseApp=firebase.initializeApp(firebaseConfig);
export default firebaseApp.firestore();

